module.exports = __webpack_public_path__ + "media/images/icons/blue-close-67585af14d375158a3b10c721a96220d.svg";